var indentation_default = {
  "indentZero": "Qa8lH",
  "indentOne": "_6W8Lq",
  "indentTwo": "CKo33",
  "indentThree": "HXkzG",
  "indentFour": "J7spR",
  "indentFive": "viGWH",
  "indentSix": "uuaYo"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
